export enum InkActionsTypes {
  INK_READ = "@@INK read ",
  INK_READ_STATUS = "@@INK read  status",
  PATCH_ONE = "@@INK patch one ink",
  PATCH_ONE_STATUS = "@@INK patch one status ink",
  CREATE_ONE = "@@INK create one ink",
  CREATE_ONE_STATUS = "@@INK create one status ink"
}
